__turbopack_context__.v({
  "dark": "theme-module__IdVcHq__dark",
  "light": "theme-module__IdVcHq__light",
});
